import {
  HStack,
  IconProps,
  Pressable,
  Text,
} from "@whoosh/design-system/src/components/primitive";

type NavigationMenuItemProps = {
  label: string;
  icon: (props: IconProps) => React.JSX.Element;
  selected: boolean;
  onPress: () => void;
  testID?: string;
};

export const NavigationMenuItem = ({
  label,
  icon,
  selected,
  onPress,
  testID,
}: NavigationMenuItemProps) => (
  <Pressable
    onPress={onPress}
    paddingHorizontal={4}
    paddingVertical={3}
    borderRadius="2"
    backgroundColor={selected ? "surface-secondary" : "surface-primary"}
    _hover={{ backgroundColor: "grayscale-200" }}
    _pressed={{ backgroundColor: "grayscale-500" }}
    testID={testID}
  >
    <HStack alignItems="center" gap={4}>
      {icon({ color: "text-primary", fill: "none" })}
      <Text variant="mainBaseMedium" color="text-primary">
        {label}
      </Text>
    </HStack>
  </Pressable>
);
